module.exports = __webpack_public_path__ + "img/fogg-order-completed.0218d3ab.png";